import React from "react";
import { Button, IconButton, Modal, Text } from "@/ui";
import { useNotification } from "@/hooks";
import { Icon } from "@/components";

const GenerateTempPasswordModal = ({ isOpen, toggle, newPassword }) => {
    const notify = useNotification();

    const clipboardCopy = password => {
        navigator.clipboard.writeText(password);
        toggle(null);
        notify(`Password: ${password} is copied`, "success");
    };

    return (
        <Modal
            footer={
                <Button
                    onClick={() => toggle(null)}
                    type="button"
                    variant="secondary"
                >
                    Close
                </Button>
            }
            onOpenChange={open => {
                if (!open) toggle(null);
            }}
            open={Boolean(isOpen)}
            size="md"
            title="Password Generated"
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    flexWrap: "wrap",
                }}
            >
                <Text variant="body-md">{newPassword}</Text>
                <IconButton
                    aria-label="Copy password generated"
                    onClick={() => clipboardCopy(newPassword)}
                    size="sm"
                    type="button"
                    variant="tertiary"
                >
                    <Icon color="#727a94" icon="copy" />
                </IconButton>
            </div>
        </Modal>
    );
};

export default GenerateTempPasswordModal;
